import script from "./BaseHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseHeader.vue?vue&type=script&setup=true&lang=js"

import "./BaseHeader.vue?vue&type=style&index=0&id=3bf8970c&lang=scss&scoped=true"

import exportComponent from "/Users/hpy/monetware/项目/product-home-html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf8970c"]])

export default __exports__